module.exports = __webpack_public_path__ + "img/iconCC-Social4.1bd00184.png";